import { variablesGlobales } from '../../configs/variables';
import getInstanceAxios from '../axiosInstance';


export class UtmLeadService {

    static async createUtmLead(data={}) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/utm-leads/createUtm`, data);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data?.message,
                date: new Date(),
                code: error.code,
                status: error?.response?.status
            }
        }
    }

    static async validateHasNotified(operationIdUtm="") {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.get(`${variablesGlobales.urlServiceBackend}/api/v1/utm-leads/getByOperationId?operationId=${operationIdUtm}`);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data?.message,
                date: new Date(),
                code: error.code,
                status: error?.response?.status
            }
        }
    }

    static async updateUtmLead(operationIdUtm="", data={}) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.put(`${variablesGlobales.urlServiceBackend}/api/v1/utm-leads/update/${operationIdUtm}`, data);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data?.message,
                date: new Date(),
                code: error.code,
                status: error?.response?.status
            }
        }
    }
}